(() => {
  const finder = document.querySelector('[data-cn-finder]');
  if (!finder) return;

  const panel = finder.querySelector('[data-cn-finder-panel]');
  const result = finder.querySelector('[data-cn-finder-result]');
  const resultTitle = finder.querySelector('[data-cn-finder-result-title]');
  const resultCopy = finder.querySelector('[data-cn-finder-result-copy]');
  const resultLink = finder.querySelector('[data-cn-finder-result-link]');
  const openTriggers = Array.from(document.querySelectorAll('[data-cn-open-finder]'));
  let lastFocused = null;
  let activeTrigger = null;
  let selectedProject = '';
  let closeTimer = null;

  openTriggers.forEach((trigger) => {
    trigger.setAttribute('aria-controls', finder.id);
    trigger.setAttribute('aria-expanded', 'false');
  });

  const getFocusableElements = () => Array.from(
    panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter((element) => element.getClientRects().length > 0);

  const track = (eventName, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...detail });
  };

  const openFinder = (trigger) => {
    window.clearTimeout(closeTimer);
    lastFocused = trigger || document.activeElement;
    activeTrigger = trigger || null;
    openTriggers.forEach((item) => item.setAttribute('aria-expanded', item === activeTrigger ? 'true' : 'false'));
    finder.hidden = false;
    document.body.classList.add('cn-finder-active');
    requestAnimationFrame(() => {
      finder.classList.add('is-open');
      panel.focus();
    });
    track('finish_finder_opened');
  };

  const closeFinder = () => {
    finder.classList.remove('is-open');
    document.body.classList.remove('cn-finder-active');
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
    closeTimer = window.setTimeout(() => {
      finder.hidden = true;
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      activeTrigger = null;
    }, 280);
  };

  const selectChoice = (choice, selector) => {
    finder.querySelectorAll(selector).forEach((button) => {
      button.setAttribute('aria-pressed', button === choice ? 'true' : 'false');
    });
  };

  const showRecommendation = (choice) => {
    let route = choice.dataset.route;
    let title = choice.dataset.title;
    let copy = choice.dataset.copy;

    if (
      selectedProject === 'worktops' &&
      (choice.dataset.cnResultChoice === 'oil' || choice.dataset.cnResultChoice === 'protection')
    ) {
      route = '/products/worktop-oil';
      title = 'Worktop Oil';
      copy = 'Purpose-built oil protection for worktops, tables, cutting boards, and food-contact wood.';
    }

    resultTitle.textContent = title;
    resultCopy.textContent = copy;
    resultLink.href = route;
    resultLink.textContent = `Explore ${title}`;
    result.hidden = false;
    result.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'nearest'
    });

    track('finish_finder_result', {
      finish_finder_project: selectedProject || 'not_selected',
      finish_finder_goal: choice.dataset.cnResultChoice,
      finish_finder_route: route
    });
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-cn-open-finder]');
    if (openTrigger) {
      event.preventDefault();
      openFinder(openTrigger);
      return;
    }

    if (!finder.hidden && event.target.closest('[data-cn-close-finder]')) {
      closeFinder();
      return;
    }

    const projectChoice = event.target.closest('[data-cn-project-choice]');
    if (projectChoice && finder.contains(projectChoice)) {
      selectedProject = projectChoice.dataset.cnProjectChoice;
      selectChoice(projectChoice, '[data-cn-project-choice]');
      return;
    }

    const resultChoice = event.target.closest('[data-cn-result-choice]');
    if (resultChoice && finder.contains(resultChoice)) {
      selectChoice(resultChoice, '[data-cn-result-choice]');
      showRecommendation(resultChoice);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (finder.hidden) return;

    if (event.key === 'Escape') {
      closeFinder();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = getFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  resultLink.addEventListener('click', () => {
    track('finish_finder_recommendation_clicked', {
      finish_finder_route: resultLink.getAttribute('href')
    });
  });
})();

(() => {
  const careFinder = document.querySelector('[data-cn-care-finder]');
  if (!careFinder) return;

  const result = careFinder.querySelector('[data-cn-care-result]');
  const title = careFinder.querySelector('[data-cn-care-title]');
  const copy = careFinder.querySelector('[data-cn-care-copy]');
  const preparation = careFinder.querySelector('[data-cn-care-preparation]');
  const use = careFinder.querySelector('[data-cn-care-use]');
  const risk = careFinder.querySelector('[data-cn-care-risk]');
  const primaryLink = careFinder.querySelector('[data-cn-care-link]');
  let selectedSurface = '';
  let selectedFinish = '';
  let selectedNeed = '';
  let selectedSite = '';
  let selectedInstructions = '';

  const products = {
    pu: {
      title: 'PU Cleaner', route: '/products/pu-cleaner', action: 'View PU Cleaner',
      copy: 'For routine or post-installation cleaning of resilient floors with a confirmed factory PU/PUR finish or compatible Dr. Schutz permanent sealer.',
      preparation: 'Sweep or vacuum loose soil before damp cleaning.',
      routineUse: 'Routine cleaning: 1:200, or 50 mL in 10 L of water. Damp-mop without flooding.',
      deepUse: 'Post-installation or stubborn soil: up to 1:10. Allow a short dwell time, agitate, recover the solution, and rinse with clear water.',
      risk: 'Confirm the PU/PUR system first. Avoid spraying nearby wood, metal, furnishings, or other sensitive surfaces.'
    },
    spraymax: {
      title: 'Spraymax + Spray Mop', route: '/products/spraymax-dr-schutz', action: 'View Spraymax',
      copy: 'A controlled, low-moisture routine for compatible hard floors including LVT, sealed wood, sealed cork, laminate, tile, and stone.',
      preparation: 'Remove loose dust and grit before cleaning.',
      use: 'Ready to use. Apply a fine controlled spray and wipe with the Spray Mop cover.',
      risk: 'Do not leave standing water on laminate, wood, cork, edges, or joints.'
    },
    laminate: {
      title: 'Laminate Cleaner', route: '/products/laminate-cleaner-dr-schutz', action: 'View Laminate Cleaner',
      copy: 'The dedicated neutral cleaner for routine maintenance of laminate and laminated surfaces.',
      preparation: 'Sweep or vacuum loose soil.',
      use: 'Dilute 1:200, or 50 mL in 10 L of water. Wipe lightly damp with a thoroughly wrung-out mop.',
      risk: 'Never leave puddles. Moisture must not remain at edges, joints, or damaged seams.'
    },
    esd: {
      title: 'ESD Floor Cleaner', route: '/products/esd-floor-cleaner-dr-schutz', action: 'View ESD Floor Cleaner',
      copy: 'For routine or post-construction cleaning of conductive and electrostatically dissipative flooring systems.',
      preparation: 'Sweep or vacuum loose soil and preserve the documented ESD testing protocol.',
      routineUse: 'Routine manual cleaning: 1:200, or 50 mL in 10 L of water. For an automatic scrubber, use up to 1:400, or 25 mL in 10 L.',
      deepUse: 'Final or post-construction cleaning: 1:10, or 1 L in 10 L. Spread generously, allow 10 minutes, scrub with a mop or single-disc machine and red pad, recover the solution, then wipe streak-free with clean water.',
      risk: 'Use within the specified ESD maintenance system. Follow the floor manufacturer\'s maintenance and resistance-testing requirements.'
    },
    elatex: {
      title: 'Elatex / USR Universal Stain Remover', route: '/products/elatex-usr-universal-stain-remover', action: 'View Elatex / USR',
      copy: 'For heel marks, adhesive residue, and localized stubborn stains on compatible resilient, lacquered wood, stone, and synthetic surfaces.',
      preparation: 'Remove loose soil and absorb liquids. Test colorfastness in an inconspicuous area.',
      use: 'Apply to a soft lint-free cloth and dab from the edge toward the center. Treat with clear water and dab dry.',
      risk: 'Do not rub textile stains. A polymer-coated floor may need compatible care-film restoration afterward.'
    },
    cleanStrip: {
      title: 'Clean and Strip', route: '/products/clean-and-strip-dr-schutz', action: 'View Clean and Strip',
      copy: 'The general option for post-installation cleaning and ordinary care-film removal from compatible vinyl, linoleum, and rubber flooring.',
      preparation: 'Sweep or vacuum first and work in manageable sections.',
      deepUse: 'Post-installation cleaning: dilute 1:5 to 1:10 and allow approximately 10 minutes before agitation and recovery.',
      stripUse: 'Care-film removal: 1:5 for domestic use; undiluted to 1:3 for commercial use. Allow approximately 15-20 minutes, then recover and rinse thoroughly.',
      risk: 'This is not a routine cleaner. Do not let the solution dry and do not spray wood, metal, varnished, or sensitive surfaces.'
    },
    turbo: {
      title: 'Turbo-Strip', route: '/products/turbo-strip', action: 'View Turbo-Strip',
      copy: 'The faster professional option for stubborn, aged, or multilayer care films on compatible resilient flooring.',
      preparation: 'Sweep or vacuum and test material compatibility before professional stripping.',
      use: 'Dilute 1:1 to 1:5 depending on film resistance. Allow approximately 5-15 minutes, agitate, recover, and rinse thoroughly.',
      risk: 'Not for routine cleaning, solvent-sensitive floors, or permanent sealer systems.'
    },
    floorMat: {
      title: 'Floor Mat', route: '/products/renew-1-step-cleaner-750ml-copy', action: 'View Floor Mat',
      copy: 'A matte sacrificial care film for compatible floors where the manufacturer permits this type of protective coating.',
      preparation: 'Thoroughly clean and dry the floor. Prime or seal porous substrates where required.',
      use: 'Shake well and apply undiluted in one thin, even film. Allow to dry overnight before use.',
      risk: 'Do not use where care films are prohibited. Confirm adhesion on factory UV/PU finishes and conditional substrates.'
    },
    floorShine: {
      title: 'Floor Shine', route: '/products/floor-shine', action: 'View Floor Shine',
      copy: 'A glossy polymer care film for compatible PVC, LVT, prepared linoleum, and lacquered wood floors.',
      preparation: 'Thoroughly clean and dry the floor before application.',
      use: 'At a minimum room and floor temperature of 15 C, apply undiluted in a thin, even film. Use cautiously for 12 hours after the last coat dries.',
      risk: 'Do not apply unless the flooring manufacturer permits a care film and adhesion has been confirmed.'
    },
    scratchFix: {
      title: 'ScratchFix PU Floor Repair Set', route: '/products/scratchfix-pu-floor-repair-set', action: 'View ScratchFix',
      copy: 'For cosmetic concealment of fine scratches and white stress lines in compatible PU/PUR resilient wear layers.',
      preparation: 'Clean and degrease the area, remove raised edges, lightly level where instructed, and remove dust.',
      use: 'Use the repair pen for individual scratches or 2-3 light spray coats for fine scratches, following the current label. Return to use is approximately 6 hours under documented conditions.',
      risk: 'Only for compatible PU/PUR resilient floors. Aerosol label and SDS safety rules apply.'
    },
    hardWax: {
      title: 'Hard-Wax Repair Kit', route: '/products/repair-kit-wood-laminate-cork-resilient-floors', action: 'View Repair Kit',
      copy: 'For localized cosmetic filling of deeper scratches, chips, or missing material in wood, laminate, cork, and compatible resilient floors.',
      preparation: 'Trim loose material, soften sharp edges, clean the damage, and select a compatible wax color blend.',
      use: 'Melt and blend wax into a slight overfill, remove excess, recreate grain if needed, adjust gloss, and seal only as directed. Allow approximately 6 hours after final sealing.',
      risk: 'Not a structural repair and not suitable for active water damage or movement.'
    },
    renew: {
      title: 'ReNew 1-Step Cleaner', route: '/products/renew-1-step-cleaner', action: 'View ReNew 1-Step',
      copy: 'A controlled recommendation for compatible tile and stone floor cleaning.',
      preparation: 'Test compatibility in an inconspicuous area.',
      use: 'Follow the current container label and technical instructions exactly; no verified dilution or dwell time is available in the supplied product information.',
      risk: 'Highly flammable and corrosive concentrate. The current label and SDS are mandatory; do not improvise application or safety instructions.'
    },
    designSet: {
      title: 'Design Floor Care Set', route: '/products/design-floor-care-set-dr-schutz', action: 'View Design Floor Care Set',
      copy: 'A coordinated set for compatible LVT and resilient design flooring using PU Cleaner and Floor Mat.',
      preparation: 'Confirm compatibility with both PU Cleaner and a matte care film before use.',
      use: 'Use each component only for its documented purpose: cleaner for cleaning, Floor Mat for compatible matte protection, and the white pad for localized marks.',
      risk: 'Do not apply Floor Mat where the manufacturer prohibits sacrificial care films.'
    }
  };

  const guidance = (titleText, copyText) => ({
    title: titleText,
    copy: copyText,
    preparation: 'Collect the flooring manufacturer, material, finish, and prior-maintenance information. Test only after compatibility is confirmed.',
    use: 'No product or dilution should be selected until the floor system is identified.',
    risk: 'Guessing can change sheen, weaken the finish, leave residue, or interfere with an existing maintenance system.',
    route: '/pages/contact-us',
    action: 'Ask a Floor-Care Specialist'
  });

  const setSelected = (button, selector) => {
    careFinder.querySelectorAll(selector).forEach((choice) => {
      choice.setAttribute('aria-pressed', choice === button ? 'true' : 'false');
    });
  };

  const chooseRecommendation = () => {
    if (selectedSurface === 'unknown' || selectedFinish === 'unknown') {
      return guidance('Confirm the floor system first', 'The material or existing finish is not confirmed, so a reliable product recommendation cannot be made yet.');
    }

    if (selectedInstructions === 'restricted') {
      return guidance('Preserve the specified maintenance system', 'An existing maintenance system must be preserved. Confirm the approved product list before introducing another cleaner, stripper, or care film.');
    }

    if (selectedFinish === 'oil-wax') {
      return guidance('Use an oil-compatible maintenance system', 'The current Dr. Schutz selector source does not verify an oil or wax maintenance product for this floor. Confirm the original finishing system first.');
    }

    if (selectedSurface === 'esd') {
      if (selectedNeed === 'routine' || selectedNeed === 'deep') return { ...products.esd, use: selectedNeed === 'deep' ? products.esd.deepUse : products.esd.routineUse };
      return guidance('Protect the ESD specification', 'Repair, stripping, and care-film decisions must preserve electrical performance and the documented resistance-testing protocol.');
    }

    if (selectedNeed === 'localized-stain') {
      return products.elatex;
    }

    if (selectedNeed === 'fine-scratch') {
      if (selectedSurface === 'resilient' && (selectedFinish === 'factory-pu' || selectedFinish === 'permanent-sealer')) return products.scratchFix;
      return guidance('Confirm the wear layer before cosmetic repair', 'ScratchFix is verified only for compatible PU/PUR resilient wear layers and permanent sealer systems.');
    }

    if (selectedNeed === 'deep-damage') {
      if (['resilient', 'laminate', 'sealed-wood-cork'].includes(selectedSurface)) return products.hardWax;
      return guidance('Assess the damage before repair', 'The documented hard-wax kit is a localized cosmetic repair, not a structural or water-damage solution.');
    }

    if (selectedNeed === 'strip') {
      if (!['resilient', 'linoleum-rubber'].includes(selectedSurface) || selectedFinish === 'permanent-sealer') {
        return guidance('Do not strip this system yet', 'The selected surface or permanent sealer is not a verified match for routine care-film stripping.');
      }
      if (selectedSite === 'commercial') return products.turbo;
      return { ...products.cleanStrip, use: products.cleanStrip.stripUse };
    }

    if (selectedNeed === 'matte-refresh') {
      if (['resilient', 'linoleum-rubber'].includes(selectedSurface) && selectedInstructions === 'confirmed') return products.floorMat;
      return guidance('Confirm that a matte care film is permitted', 'Floor Mat is a sacrificial coating, not an ordinary detergent, and should not be used where care films are prohibited.');
    }

    if (selectedNeed === 'gloss-refresh') {
      if (['resilient', 'sealed-wood-cork'].includes(selectedSurface) && selectedInstructions === 'confirmed') return products.floorShine;
      return guidance('Confirm that a glossy care film is permitted', 'Floor Shine requires a compatible, thoroughly cleaned, dry surface and manufacturer approval for a polymer care film.');
    }

    if (selectedNeed === 'kit') {
      if (selectedSurface === 'resilient' && ['factory-pu', 'permanent-sealer'].includes(selectedFinish) && selectedInstructions === 'confirmed') return products.designSet;
      return guidance('Build the kit around the confirmed finish', 'A complete kit is only useful when every cleaner and care film is compatible with the existing system.');
    }

    if (selectedNeed === 'deep') {
      if (selectedSurface === 'tile-grout') return products.renew;
      if (selectedSurface === 'laminate') return products.laminate;
      if (['resilient', 'linoleum-rubber'].includes(selectedSurface)) {
        if (selectedFinish === 'factory-pu' || selectedFinish === 'permanent-sealer') return { ...products.pu, use: products.pu.deepUse };
        return { ...products.cleanStrip, use: products.cleanStrip.deepUse };
      }
      return guidance('Confirm a deep-cleaning method', 'Aggressive cleaning can damage sealed wood, cork, and unknown coatings. Confirm the finish and approved method first.');
    }

    if (selectedNeed === 'routine') {
      if (selectedSurface === 'laminate') return products.laminate;
      if (selectedSurface === 'sealed-wood-cork') return products.spraymax;
      if (selectedSurface === 'tile-grout') return products.spraymax;
      if (['resilient', 'linoleum-rubber'].includes(selectedSurface)) {
        if (selectedFinish === 'factory-pu' || selectedFinish === 'permanent-sealer') return { ...products.pu, use: products.pu.routineUse };
        if (selectedSurface === 'resilient') return products.spraymax;
      }
    }

    return guidance('Confirm compatibility before proceeding', 'The selected combination does not have a sufficiently verified product match in the current maintenance knowledge base.');
  };

  const showResult = () => {
    if (!selectedSurface || !selectedFinish || !selectedNeed || !selectedSite || !selectedInstructions) return;

    const recommendation = chooseRecommendation();

    title.textContent = recommendation.title;
    copy.textContent = recommendation.copy;
    preparation.textContent = recommendation.preparation;
    use.textContent = recommendation.use;
    risk.textContent = recommendation.risk;
    primaryLink.href = recommendation.route;
    primaryLink.textContent = recommendation.action;

    result.hidden = false;
    result.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'nearest'
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'care_finder_result',
      care_surface: selectedSurface,
      care_finish: selectedFinish,
      care_need: selectedNeed,
      care_site: selectedSite,
      care_instructions: selectedInstructions,
      care_route: recommendation.route
    });
  };

  careFinder.addEventListener('click', (event) => {
    const surfaceButton = event.target.closest('[data-cn-care-surface]');
    if (surfaceButton) {
      selectedSurface = surfaceButton.dataset.cnCareSurface;
      setSelected(surfaceButton, '[data-cn-care-surface]');
      showResult();
      return;
    }

    const finishButton = event.target.closest('[data-cn-care-finish]');
    if (finishButton) {
      selectedFinish = finishButton.dataset.cnCareFinish;
      setSelected(finishButton, '[data-cn-care-finish]');
      showResult();
      return;
    }

    const needButton = event.target.closest('[data-cn-care-need]');
    if (needButton) {
      selectedNeed = needButton.dataset.cnCareNeed;
      setSelected(needButton, '[data-cn-care-need]');
      showResult();
      return;
    }

    const siteButton = event.target.closest('[data-cn-care-site]');
    if (siteButton) {
      selectedSite = siteButton.dataset.cnCareSite;
      setSelected(siteButton, '[data-cn-care-site]');
      showResult();
      return;
    }

    const instructionsButton = event.target.closest('[data-cn-care-instructions]');
    if (instructionsButton) {
      selectedInstructions = instructionsButton.dataset.cnCareInstructions;
      setSelected(instructionsButton, '[data-cn-care-instructions]');
      showResult();
    }
  });
})();

(() => {
  const drawer = document.getElementById('MenuDrawer');
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  let lastMobileTrigger = null;
  let returnFocusTimer = null;
  if (!drawer) return;

  const isOpen = () => (
    mobileViewport.matches &&
    !drawer.hasAttribute('hidden') &&
    Array.from(document.querySelectorAll('[aria-controls="MenuDrawer"]'))
      .some((control) => control.getAttribute('aria-expanded') === 'true')
  );

  const getVisibleFocusable = () => Array.from(
    drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter((element) => {
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return (
      element.tabIndex >= 0 &&
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > 0 &&
      rect.left < window.innerWidth &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight &&
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  });

  const returnFocusToTrigger = () => {
    window.clearTimeout(returnFocusTimer);
    returnFocusTimer = window.setTimeout(() => {
      lastMobileTrigger?.focus({ preventScroll: true });
    }, 420);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('button.menu-drawer-button[aria-controls="MenuDrawer"]');
    if (!mobileViewport.matches) return;

    if (!trigger) {
      if (event.target.closest('#MenuDrawer .drawer__close') && isOpen()) returnFocusToTrigger();
      return;
    }

    lastMobileTrigger = trigger;

    window.setTimeout(() => {
      if (!isOpen()) return;
      drawer.querySelector('.drawer__close')?.focus({ preventScroll: true });
    }, 320);
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      returnFocusToTrigger();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getVisibleFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const activeIsInside = drawer.contains(document.activeElement);

    if (!activeIsInside || (event.shiftKey && document.activeElement === first)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);
})();

/* Document-grounded Dr. Schutz care guide */
(() => {
  const assistants = document.querySelectorAll('[data-cn-care-assistant]');
  if (!assistants.length) return;

  assistants.forEach((assistant) => {
    const form = assistant.querySelector('[data-cn-care-assistant-form]');
    const response = assistant.querySelector('[data-cn-care-assistant-response]');
    const status = assistant.querySelector('[data-cn-care-assistant-status]');
    const answer = assistant.querySelector('[data-cn-care-assistant-answer]');
    const sources = assistant.querySelector('[data-cn-care-assistant-sources]');
    const button = form && form.querySelector('button[type="submit"]');
    const endpoint = assistant.dataset.endpoint;
    if (!form || !response || !endpoint) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const question = new FormData(form).get('question');
      if (!question || String(question).trim().length < 4) return;

      const finder = assistant.parentElement && assistant.parentElement.querySelector('[data-cn-care-finder]');
      const context = { page: window.location.pathname };
      if (finder) {
        finder.querySelectorAll('input:checked, select').forEach((field) => {
          if (field.name && field.value) context[field.name] = field.value;
        });
      }

      response.hidden = false;
      status.textContent = 'Reviewing the technical documentation...';
      answer.textContent = '';
      sources.hidden = true;
      sources.textContent = '';
      button.disabled = true;
      assistant.setAttribute('aria-busy', 'true');

      try {
        const request = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ question: String(question).trim(), context }),
        });
        const payload = await request.json();
        if (!request.ok) throw new Error(payload.error || 'The technical guide is unavailable.');

        status.textContent = 'Technical guidance';
        answer.textContent = payload.answer;
        if (Array.isArray(payload.sources) && payload.sources.length) {
          sources.textContent = `Documentation consulted: ${payload.sources.join(', ')}`;
          sources.hidden = false;
        }
      } catch (error) {
        status.textContent = 'Unable to complete the review';
        answer.textContent = error.message || 'Please try again in a moment.';
      } finally {
        button.disabled = false;
        assistant.removeAttribute('aria-busy');
      }
    });
  });
})();
